import React, { useEffect } from "react";
import { Combobox, Toast, AddTeam } from "../..";
import { useState } from "react";
import { apis, get } from "../../../Utils/axios";
import { TbBuilding } from "react-icons/tb";

function TeamSearch({
	onSelect = () => {},
	placeholder = "Search Teams",
	label,
	selected = {},
	className = "",
	authCode,
	searchOnly = false,
	prefetch = true,
}) {
	const [AllTeams, setAllTeams] = useState([]);
	const [Loader, setLoader] = useState();

	const fetchTeams = (query) => {
		setLoader(true);
		const params = { page: 1, code: authCode };
		if (query) {
			params.search = query;
		}

		//Use admin api only for admin
		get(authCode ? apis.searchTeamsForOnboarding : apis.getAllTeams, params, (r, e) => {
			if (r) {
				setAllTeams(r.teams);
				setLoader(false);
			} else if (e) {
				console.log(e);
				Toast.handleError(e);
				setLoader(false);
			}
		});
	};

	const onChange = (query) => {
		fetchTeams(query);
	};

	useEffect(() => {
		if (prefetch) {
			fetchTeams("");
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [prefetch, authCode]);

	return (
		<div className="flex flex-col w-full gap-2 sm:flex-row sm:items-end">
			<Combobox
				loading={Loader}
				label={label}
				placeholder={placeholder}
				className={`w-full ${className}`}
				onChange={onChange}
				options={AllTeams.map((team) => ({
					...team,
					label: team.name,
					value: team.id,
					office: team.office?.name,
				}))}
				renderItem={(option, active, selected) => (
					<li className={`${active ? "bg-light" : "bg-white"}`}>
						<div>{option.label}</div>
						<div className="gap-2 align-center">
							<TbBuilding /> {option.office}
						</div>
					</li>
				)}
				selected={selected}
				onSelect={onSelect}
			/>
			{!searchOnly && <AddTeam btnLabel="+ New" btnClass="w-full sm:w-auto" />}
		</div>
	);
}

export default TeamSearch;
